<template>
	<div class="overflowxHidden">

		<!-- <header class="lmy-search-header">
	        <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
	        <div class="lmy-filter-box">
	            <div class="header-filter-box">
	                <p> 
	                	<label @click="calendar.show=true">住 <span>{{CheckIn|dateMMDD}}</span>
	                	</label>
	                	<label @click="rpData.show=true">
	                	 成人 <span>{{AdultCount}}</span>
	                	</label>
	                </p>
	                <p>
	                	<label @click="calendar.show=true">离 <span>{{CheckOut|dateMMDD}}</span>
	                	</label>
	                	<label @click="rpData.show=true">  儿童 <span>{{ChildrenCount}}</span>
	                	</label>
	                </p>
	            </div>
				<div class="search-text" >
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-sousuo"></use>
					</svg>
	                <input type="text" placeholder="酒店名称/商圈/关键字" readonly="readonly" v-model="Name" @click="shData.show=true"/>
					<i class="iconfont icon-close text-remove" @click="Name='';changeFilter()" v-if="Name"></i>
				</div>
	        </div>
	    </header> -->

		<header class="search-header">
	        <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
			<div class="search-time fr-search-time">
				<p> 
					<span  @click="calendar.show=true">住</span> <span  @click="calendar.show=true" class="time">{{CheckIn|dateMMDD}}</span> <span  @click="rpData.show=true">&nbsp;成人</span> <span  @click="rpData.show=true" class="time">{{AdultCount}}</span>
				</p>
				<p>
					<span  @click="calendar.show=true">离</span> <span  @click="calendar.show=true" class="time">{{CheckOut|dateMMDD}}</span> <span  @click="rpData.show=true">&nbsp;儿童</span> <span  @click="rpData.show=true" class="time">{{ChildrenCount}}</span>
				</p>
			</div>
			<div class="search-text" >
				<svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-sousuo"></use>
						</svg>
				<input type="text" placeholder="酒店/商圈/关键字" v-model="Name" readonly="readonly" @click="shData.show=true;"/>
				<i class="iconfont icon-close text-remove" @click="Name='';changeFilter()" v-if="Name"></i>
			</div>
		</header>

	    <ul class="lmy-filter-bar">

	       <li :class="hotelSortData.showAddress?'item active fr-item':'item fr-item'" @click="hotelSortData.showAddress=!hotelSortData.showAddress;hotelSortData.showStar=false;">
	       	  	<label> 
	            	位置
		        	<i :class="hotelSortData.showAddress?'iconfont xiala active':'iconfont xiala'"></i>
		    	</label>
	       </li>
	       <li :class="hotelSortData.showStar?'item active fr-item':'item fr-item'" @click="hotelSortData.showStar=!hotelSortData.showStar;hotelSortData.showAddress=false;">
	       		<label> 
		           	星级
			        <i :class="hotelSortData.showStar?'iconfont xiala active':'iconfont xiala'"></i>
			    </label>
	       </li>
	    </ul>

	    <div class="lmy-filter-container">
        	<div class="list-item" v-for="item in list" @click="routeToDetails(item)">
	            <div class="item-img">
	            	<img :src="item.Pics[0].Url|replaceImgSrc(3)" v-if="item.Pics&&item.Pics[0]" alt="">
	                <img src="./../../assets/img/hotelDf.png" v-if="!item.Pics||!item.Pics[0]||item.Pics[0].Url=='/'" alt="">
	                <i v-if="item.RecommendLevel==1" class="sell-i-word">主推</i>
					<i v-if="item.RecommendLevel==2" class="sell-i-word">特推</i>
	              
	            </div> 
	             <div class="item-content">
	                <h3 class="title">{{item.HotelName||item.HotelEName}}</h3>
	                <p class="score">{{item.HotelEName}}</p>

	                <p class="score"><span>{{item.HotelLevel}} </span></p>
	                <p class="score">{{item.Address}}</p>
	                <p class="score-text">{{item.LocationCN}}</p>

	                <p class="distance">{{item.Distance}}</p>
	                <p class="address">{{item.DistrictName||''}}  {{item.Landmark?" | "+item.Landmark:''}}</p>
	           
	                <div class="config">
						<i v-for="eqmt in item.Facilities" :class="'iconfont  icon-f-'+eqmt"></i>
	                </div>

	                <div class="status" v-if="item.Attr!=0&&item.Attr">
	                	<img class="icon-price-tags" v-if="(item.Attr & 1)==1" src="./../../assets/img/lian.svg" />
						<img class="icon-price-tags" v-if="(item.Attr & 2)==2" src="./../../assets/img/zao.svg"  />
						<img class="icon-price-tags" v-if="(item.Attr & 4)==4" src="./../../assets/img/tuan.svg" />

	                </div>
	                <div class="price" v-if="From==1&&item.LowestPrice>0">¥<span>{{item.LowestPrice}}</span>起</div>
	                <div class="price" v-if="From==1&&item.LowestPrice==-1">售罄</div>
	            </div>
	        </div>


	    </div>
		<transition  name="slide" >
			<DatePicker @select="calendar.select" :start="calendar.start" :beginDate="calendar.begin" :endDate="calendar.end" :monthLength="calendar.monthLength"  v-show="calendar.show" ></DatePicker>
		</transition>
		<transition  name="slide" >
			<SearchHotel @select="shData.select" :RegionID="RegionID" :shData="shData"  v-show="shData.show" ></SearchHotel>
		</transition>
		<roomAndPerson @select="rpData.select" v-show="rpData.show" :rpData="rpData" ></roomAndPerson>
		<HotelSort  @selectSortTypes="hotelSortData.selectSortTypes" @selectStar="hotelSortData.selectStar" @selectPrice="hotelSortData.selectPrice" @selectLandmark="hotelSortData.selectLandmark"  v-show="hotelSortData.showAddress||hotelSortData.showStar" :hotelSortData="hotelSortData"></HotelSort>
		<infinite-loading @infinite="initData" ref="infiniteLoading">
		  <span slot="no-more">
		   没有更多了...
		  </span>	
		  <span slot="no-results">
		   没有相关酒店...
		  </span>
		</infinite-loading>
	</div>
</template>
<script>
	import InfiniteLoading from 'vue-infinite-loading';
	import DatePicker from './../common/cmpnt/datePicker/datePicker.vue'//日期选择器
	import HotelSort from './../common/cmpnt/hotelSort.vue'//酒店条件筛选
	import roomAndPerson from './../common/cmpnt/roomAndPerson.vue'//酒店房间和入住人数
	import SearchHotel from './../common/cmpnt/searchHotel.vue'//搜索酒店
	import ImgLoader from './../common/cmpnt/imgLoader/imgLoader.vue'//图片异步加载+效果
	export default{
		name:'hotelList',
		components:{
			InfiniteLoading,
			DatePicker,
			HotelSort,
			SearchHotel,
			roomAndPerson,
			ImgLoader
		},
		data(){
			return{
				params:JSON.parse(this.dao.get('')),
				RegionID:JSON.parse(this.dao.get('frHotelListSearchParams')).RegionID,
				MyCityRegionID:JSON.parse(this.dao.get('frHotelListSearchParams')).MyCityRegionID,
				districtId:JSON.parse(this.dao.get('frHotelListSearchParams')).districtId,
				CityName:JSON.parse(this.dao.get('frHotelListSearchParams')).CityName,
				StarName:JSON.parse(this.dao.get('frHotelListSearchParams')).StarName,
				From:0,
				Name:JSON.parse(this.dao.get('frHotelListSearchParams')).Name,
				Landmark:JSON.parse(this.dao.get('frHotelListSearchParams')).Landmark,
				LandmarkCode:JSON.parse(this.dao.get('frHotelListSearchParams')).LandmarkCode||'',
				Star:JSON.parse(this.dao.get('frHotelListSearchParams')).Star,
				PriceMin:JSON.parse(this.dao.get('frHotelListSearchParams')).PriceMin,
				PriceMax:JSON.parse(this.dao.get('frHotelListSearchParams')).PriceMax,
				PriceName:JSON.parse(this.dao.get('frHotelListSearchParams')).PriceName,
				CheckIn:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn,
				CheckOut:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut,
				RoomCount:JSON.parse(this.dao.get('frHotelListSearchParams')).RoomCount,
				AdultCount:JSON.parse(this.dao.get('frHotelListSearchParams')).AdultCount,
				ChildrenCount:JSON.parse(this.dao.get('frHotelListSearchParams')).ChildrenCount,
				ChildrenAges:JSON.parse(this.dao.get('frHotelListSearchParams')).ChildrenAges,
				HotelIDs:JSON.parse(this.dao.get('frHotelListSearchParams')).HotelIDs,
				Sort:JSON.parse(this.dao.get('frHotelListSearchParams')).Sort,
				MyLat:JSON.parse(this.dao.get('frHotelListSearchParams')).MyLat,
				MyLon:JSON.parse(this.dao.get('frHotelListSearchParams')).MyLon,
				Radius:JSON.parse(this.dao.get('frHotelListSearchParams')).Radius,
				reName:'',
				Page:1,
				PageSize:10,
				FilterNOPrice:'',
				SupID:'',
				list:[],
				total:0,

				rpData:{
					show:false,
					RoomCount:JSON.parse(this.dao.get('frHotelListSearchParams')).RoomCount,
					AdultCount:JSON.parse(this.dao.get('frHotelListSearchParams')).AdultCount,
					ChildrenCount:JSON.parse(this.dao.get('frHotelListSearchParams')).ChildrenCount,
					ChildrenAges:JSON.parse(this.dao.get('frHotelListSearchParams')).ChildrenAges,
					
					from:0,
					select:(val,age)=>{
						this.rpData.show=false;
						this.RoomCount=val.RoomCount;
						this.AdultCount=val.AdultCount;
						this.ChildrenCount=val.ChildrenCount;
						var ageList=[];
                        age.forEach((item,index)=>{
                            ageList.push(item.ChildrenAges);
                        })
                        this.ChildrenAges=ageList;
						this.changeFilter();

					}
				},
				shData:{
					show:false,
					From:0,
					select:(val)=>{
						this.shData.show=false;
						this.Name=val;
						this.changeFilter();

					}
				},
				hotelSortData:{
					show:false,
					showRecommend:false,
					showAddress:false,
					showStar:false,
					// LandmarkGroups:JSON.parse(this.dao.get('LandmarkGroups')),
					priceName:JSON.parse(this.dao.get('frHotelListSearchParams')).PriceName,
					starValue:JSON.parse(this.dao.get('frHotelListSearchParams')).StarName,
					lmiName:JSON.parse(this.dao.get('frHotelListSearchParams')).Landmark,
					LandmarkCode:JSON.parse(this.dao.get('frHotelListSearchParams')).LandmarkCode,
					RegionID:JSON.parse(this.dao.get('frHotelListSearchParams')).RegionID,
					from:0,
					selectSortTypes:(val)=>{
						this.Sort=val?val:(val==0?val:this.Sort);
						this.hotelSortData.show=false;
						this.changeFilter();
					},
					selectStar:(star,name)=>{
						this.hotelSortData.show=false;
						this.hotelSortData.showStar=false;
						if(!star&&!name){
							this.Star='';
							this.starValue='';
							this.changeFilter();
							return;
						}
						this.Star=star;
						
						this.changeFilter();
					},
						
					selectPrice:(min,max,name)=>{
						this.hotelSortData.show=false;
						this.hotelSortData.showStar=false;
						if(!min&&!max&&!name){
							this.priceName='';
							this.PriceMin='';
							this.PriceMax='';
							this.changeFilter();
							return;
						}
						
						this.PriceMin=min;
						this.PriceMax=max;
						this.changeFilter();
					},
						
					selectLandmark:(lm)=>{

						
						this.hotelSortData.show=false;
						this.hotelSortData.showAddress=false;
						if(!lm){
							this.Landmark='';
							this.LandmarkCode='';
							this.Radius='';
							this.changeFilter();
							return;
						}
						if(lm.value>0){
							this.Radius=lm.value;
							this.Landmark='';
							this.LandmarkCode='';
						}else{
							this.Landmark=lm.Name;
							this.LandmarkCode=lm.ID;
							this.Radius='';
						}
						this.changeFilter();
						
						
						
					}
				},
				hotelData:{
					show:false,
					from:0,
					RegionID:'3201',
					select:(hotel)=>{
						this.Name=hotel.N;
						this.reName='';
						this.Landmark='';
						this.LandmarkCode='';
						this.districtId='';
						this.RegionName='';
						this.changeFilter();
					},
					district:(rl)=>{
						this.Landmark='';
						this.LandmarkCode='';
						this.Name='';
						this.districtId=rl.I;
						this.RegionName=rl.S||rl.N||rl.E;
						this.reName=rl.S||rl.N||rl.E;
						
						this.changeFilter();
					},
					landmark:(lm)=>{
						this.Landmark=lm.Name;
						this.LandmarkCode=lm.ID;
						this.reName=lm.Name;
						this.Name='';
						this.districtId='';
						this.RegionName='';
						this.changeFilter();
					}
				},

				calendar:{
	                monthLength:6,
	                show:false,
	                start:{year:this.getDate(0).split('-')[0],month:this.getDate(0).split('-')[1],day:this.getDate(0).split('-')[2]},
	                begin:{year:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn.split('-')[0],month:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn.split('-')[1],day:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn.split('-')[2]},
	                end:{year:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut.split('-')[0],month:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut.split('-')[1],day:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut.split('-')[2]},
	                select:(begin,end)=>{
	                	this.calendar.show=false;
	                    if(!begin||!end){
	                        this.calendar.show=false;
	                        return;
	                    }
	                    this.calendar.begin=begin;
	                    this.calendar.end=end;
	                    this.CheckIn=begin.year+'-'+begin.month+'-'+begin.day;
	                    this.CheckOut=end.year+'-'+end.month+'-'+end.day;
	                    this.changeFilter();
	                    
	                }
	            }

			}
		},
		methods:{
	 	   //条件更新后重置参数和结果
 			changeFilter($state) {

	 			this.Page=1;
	 			this.total=0;
				this.list=[]; 
		      	this.$nextTick(() => {
		      	    this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
		      	});
		    },
		    //查询酒店信息
			initData($state){
				if(this.total>0&&(((this.Page-1)*this.PageSize)>this.total)){
					$state.complete();
					return;
				}

				var that=this;
				var params={
					RegionID:that.districtId||that.RegionID,
					From:that.From,
					ProductType:0,
					Name:that.Name,
					Landmark:that.Landmark,
					LandmarkCode:that.LandmarkCode,
					Star:that.Star,
					PriceMin:that.PriceMin,
					PriceMax:that.PriceMax,
					CheckIn:that.CheckIn,
					CheckOut:that.CheckOut,
					RoomCount:that.RoomCount,
					AdultCount:that.AdultCount,
					ChildrenCount:that.ChildrenCount,
					ChildrenAges:that.ChildrenAges,
					Page:that.Page,
					PageSize:that.PageSize,
					// FilterNOPrice:that.FilterNOPrice,
					// SupID:'',
					HotelIDs:that.HotelIDs,
					Sort:that.Sort,
					MyLat:that.MyLat,
					MyLon:that.MyLon,
					Radius:that.Radius,
					MyCityRegionID:that.MyCityRegionID,

				}
				that.postRequest({
		            url: that.Api.price,
		            params: params
		        }).then(res => {
					if (res&&res.IsSuccess&&res.Result.length>0) {
						that.total=res.Total;
						that.Page++;
				        
				       	//请求或取最新的价格数据
						if(that.From==1){
							that.getLastPrice(res.Result);
						}
						that.list = that.list.concat(res.Result);
				        $state.loaded();
				    } else {
			            $state.complete();
			        }
		        });
			},
	 		//请求或取最新的价格数据
	 		getLastPrice(list){
	 			var that=this;
	 			var HotelIDs=[];

	 			list.forEach(function(item){
					HotelIDs.push(item.ID)
	 			})
	 			var param={
	 				CheckIn:this.CheckIn,
	 				CheckOut:this.CheckOut,
	 				HotelIDs:HotelIDs,
	 				From:this.From,
	 				ProductType:0,
	 				RoomCount:this.RoomCount
	 			}
    			that.postRequest({
					url:that.Api.getLowestPrices, 
					params:param
				}).then(res => {
					if (res&&res.IsSuccess) {
						var thatList=res.Result;
						for(var i=0;i<thatList.length;i++){
							for(var j=0;j<list.length;j++){
								if(list[j].ID==thatList[i].HotelID){
									list[j].LowestPrice=thatList[i].Min||-1;
									list[j].Currency=thatList[i].Currency;
									list[j].Attr=thatList[i].Attr;
								}
							}

						}
				    } 
				});	
	 			
	 		},
			//进入详情页
			routeToDetails(item){
				var obj={
					HotelID:item.ID,
					ProductType:0,
					From:this.From,
					CheckIn:this.CheckIn,
					CheckOut:this.CheckOut,
					RoomCount:this.RoomCount,
					AdultCount:this.AdultCount,
					ChildrenCount:this.ChildrenCount,
					ChildrenAges:this.ChildrenAges,
				}
			
				this.dao.set('frHotelDetailsParams',JSON.stringify(obj));

				
				//记住当前的查询条件，在详情页返回时，可以再次查询
				// this.rememberParams();
				//保存到历史记录
				this.saveHotelToHistory(item);

				this.$router.push('/frHotelDetails');

			},
			//记住查询条件，在详情页返回时重新请求数据
			rememberParams(){
				var obj={
					RegionID:this.RegionID,
					CityName:this.CityName,
					StarName:this.StarName,
					districtId:this.districtId,
					Landmark:this.Landmark,
					LandmarkCode:this.LandmarkCode,
					From:this.From,
					Name:this.Name,
					Star:this.Star,
					CheckIn:this.CheckIn,
					CheckOut:this.CheckOut,
					RoomCount:this.RoomCount,
					AdultCount:this.AdultCount,
					ChildrenCount:this.ChildrenCount,
					ChildrenAges:this.ChildrenAges,
				}
				this.dao.set('frHotelListSearchParams',JSON.stringify(obj))
			},
			//保存到历史记录
			saveHotelToHistory(hotel){
				var list=this.dao.get('hotelViewHistory')?JSON.parse(this.dao.get('hotelViewHistory')):[];
				if(list&&list.length>0){
					list.forEach((item,index)=>{
						if(item.ID==hotel.ID){
							list.splice(index,1)
						}

					})
					hotel['From']=this.From;
					hotel['date']=new Date();
					list.unshift(hotel)
				}else{
					hotel['From']=this.From;
					hotel['date']=new Date();
					list.unshift(hotel)
				}
				this.dao.set('hotelViewHistory',JSON.stringify(list));
			},
		},
	    activated(){
			if(
				this.RegionID!=JSON.parse(this.dao.get('frHotelListSearchParams')).RegionID||
				this.MyCityRegionID!=JSON.parse(this.dao.get('frHotelListSearchParams')).MyCityRegionID||
				this.districtId!=JSON.parse(this.dao.get('frHotelListSearchParams')).districtId||
				this.CityName!=JSON.parse(this.dao.get('frHotelListSearchParams')).CityName||
				this.StarName!=JSON.parse(this.dao.get('frHotelListSearchParams')).StarName||
				this.Name!=JSON.parse(this.dao.get('frHotelListSearchParams')).Name||
				this.Landmark!=JSON.parse(this.dao.get('frHotelListSearchParams')).Landmark||
				this.LandmarkCode!=JSON.parse(this.dao.get('frHotelListSearchParams')).LandmarkCode||
				this.Star!=JSON.parse(this.dao.get('frHotelListSearchParams')).Star||
				this.PriceMin!=JSON.parse(this.dao.get('frHotelListSearchParams')).PriceMin||
				this.PriceMax!=JSON.parse(this.dao.get('frHotelListSearchParams')).PriceMax||
				this.PriceName!=JSON.parse(this.dao.get('frHotelListSearchParams')).PriceName||
				this.CheckIn!=JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn||
				this.CheckOut!=JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut||
				this.RoomCount!=JSON.parse(this.dao.get('frHotelListSearchParams')).RoomCount||
				this.AdultCount!=JSON.parse(this.dao.get('frHotelListSearchParams')).AdultCount||
				this.ChildrenCount!=JSON.parse(this.dao.get('frHotelListSearchParams')).ChildrenCount||
				this.HotelIDs!=JSON.parse(this.dao.get('frHotelListSearchParams')).HotelIDs||
				this.MyLat!=JSON.parse(this.dao.get('frHotelListSearchParams')).MyLat||
				this.MyLon!=JSON.parse(this.dao.get('frHotelListSearchParams')).MyLon
			){
				this.RegionID=JSON.parse(this.dao.get('frHotelListSearchParams')).RegionID;
				this.MyCityRegionID=JSON.parse(this.dao.get('frHotelListSearchParams')).MyCityRegionID;
				this.districtId=JSON.parse(this.dao.get('frHotelListSearchParams')).districtId;
				this.CityName=JSON.parse(this.dao.get('frHotelListSearchParams')).CityName;
				this.StarName=JSON.parse(this.dao.get('frHotelListSearchParams')).StarName;
				this.Name=JSON.parse(this.dao.get('frHotelListSearchParams')).Name;
				this.Landmark=JSON.parse(this.dao.get('frHotelListSearchParams')).Landmark;
				this.LandmarkCode=JSON.parse(this.dao.get('frHotelListSearchParams')).LandmarkCode;
				this.Star=JSON.parse(this.dao.get('frHotelListSearchParams')).Star;
				this.PriceMin=JSON.parse(this.dao.get('frHotelListSearchParams')).PriceMin;
				this.PriceMax=JSON.parse(this.dao.get('frHotelListSearchParams')).PriceMax;
				this.PriceName=JSON.parse(this.dao.get('frHotelListSearchParams')).PriceName;
				this.CheckIn=JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn;
				this.CheckOut=JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut;
				this.RoomCount=JSON.parse(this.dao.get('frHotelListSearchParams')).RoomCount;
				this.AdultCount=JSON.parse(this.dao.get('frHotelListSearchParams')).AdultCount;
				this.ChildrenCount=JSON.parse(this.dao.get('frHotelListSearchParams')).ChildrenCount;
				this.HotelIDs=JSON.parse(this.dao.get('frHotelListSearchParams')).HotelIDs;
				this.MyLat=JSON.parse(this.dao.get('frHotelListSearchParams')).MyLat;
				this.MyLon=JSON.parse(this.dao.get('frHotelListSearchParams')).MyLon;
			


				this.rpData.RoomCount=JSON.parse(this.dao.get('frHotelListSearchParams')).RoomCount;
				this.rpData.AdultCount=JSON.parse(this.dao.get('frHotelListSearchParams')).AdultCount;
				this.rpData.ChildrenCount=JSON.parse(this.dao.get('frHotelListSearchParams')).ChildrenCount;

				this.hotelSortData.priceName=JSON.parse(this.dao.get('frHotelListSearchParams')).PriceName;
				this.hotelSortData.starValue=JSON.parse(this.dao.get('frHotelListSearchParams')).StarName;
				this.hotelSortData.lmiName=JSON.parse(this.dao.get('frHotelListSearchParams')).Landmark;
				this.hotelSortData.LandmarkCode=JSON.parse(this.dao.get('frHotelListSearchParams')).LandmarkCode;
				this.hotelSortData.RegionID=JSON.parse(this.dao.get('frHotelListSearchParams')).RegionID;

				this.calendar.begin={year:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn.split('-')[0],month:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn.split('-')[1],day:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckIn.split('-')[2]};
	            this.calendar.end={year:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut.split('-')[0],month:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut.split('-')[1],day:JSON.parse(this.dao.get('frHotelListSearchParams')).CheckOut.split('-')[2]};
	            this.changeFilter();
			}
		}

	}
	
</script>


// WEBPACK FOOTER //
// src/components/frHotel/list.vue